import axios from "axios";
import { baseUrl } from "../config/api-config";
import { buildQuery } from "../config/api-config";

export const getSalesList = (query, token) => {
  let qs = buildQuery(query);
  let url = `${baseUrl}/leadsfilter${qs}`;
  return axios.get(url, {
    headers: {
      authorization: token,
    },
  });
};

export const createSales = (data, token) => {
  return axios.post(`${baseUrl}/lead`, data, {
    headers: {
      authorization: token,
    },
  });
};

export const deleteSales = (id, token) =>
  axios.delete(`${baseUrl}/lead/${id}`, {
    headers: {
      authorization: token,
    },
  });

export const updateSales = (id, data, token) =>
  axios.put(`${baseUrl}/lead/${id}`, data, {
    headers: {
      authorization: token,
    },
  });

export const getPartnerLeadById = (id, token) =>
  axios.get(`${baseUrl}/lead/${id}`, {
    headers: {
      authorization: token,
    },
  });
export const getIndustryList = (token) => {
  let url = `${baseUrl}/industry-list`;
  return axios.get(url, {
    headers: {
      authorization: token,
    },
  });
};
export const getStageList = (token) => {
  let url = `${baseUrl}/stages-list`;
  return axios.get(url, {
    headers: {
      authorization: token,
    },
  });
};
export const getSalesCompanyList = (token) => {
  let url = `${baseUrl}/company-list?stages=Opportunity Won`;
  return axios.get(url, {
    headers: {
      authorization: token,
    },
  });
};

/////***Tabs in viewsales page api***/////

export const getFollowUpList = (query, token) => {
  let qs = buildQuery(query);
  let url = `${baseUrl}/follow_up-list${qs}`;
  return axios.get(url, {
    headers: {
      authorization: token,
    },
  });
};
export const getContactsList = (query, token) => {
  let qs = buildQuery(query);
  let url = `${baseUrl}/contact-list${qs}`;
  return axios.get(url, {
    headers: {
      authorization: token,
    },
  });
};
export const getNotesList = (query, token) => {
  let qs = buildQuery(query);
  let url = `${baseUrl}/notes-list${qs}`;
  return axios.get(url, {
    headers: {
      authorization: token,
    },
  });
};
